module.exports = __webpack_public_path__ + "img/versapay-design-2.447a7c93.png";